<div class="container-fluid spacer-top-navigation">
  <div class="container">
    @if (isPotentialCustomer$ | async) {
      <web-components-back-link />
    }
    <div class="tile">
      <h5 class="zero-text p-bigger-med">{{ 'onboarding.savings-plan.preview.headline' | transloco }}</h5>
      @if (facade.onboardingSavingsPlans$ | async; as savingsPlans) {
        @if (savingsPlans?.length) {
          <table class="table-depot">
            <caption>
              {{
                'onboarding.savings-plan.preview.headline' | transloco
              }}
            </caption>
            <thead>
              <tr>
                <th>
                  {{ 'savings-plan.my-savings-plans.name' | transloco }}
                  <br />
                  {{ 'savings-plan.my-savings-plans.isin' | transloco }}
                </th>
                <th>{{ 'savings-plan.my-savings-plans.rate' | transloco }}</th>
                <th>{{ 'savings-plan.my-savings-plans.interval' | transloco }}</th>
                <th>{{ 'savings-plan.my-savings-plans.next-execution' | transloco }}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @for (savingsPlan of savingsPlans; track $index) {
                <tr>
                  <td>
                    <web-components-instrument-details-link linkCssClass="zero-text p-base-med default" [isin]="savingsPlan.isin">{{
                      savingsPlan.instrumentName
                    }}</web-components-instrument-details-link>
                    <br />
                    <div class="d-flex align-items-start">
                      <div class="zero-text p-base-reg disabled text-nowrap">{{ savingsPlan.isin }}</div>
                      <web-components-watchlist-toggle [isin]="savingsPlan.isin" />
                    </div>
                  </td>
                  <td>
                    <div class="d-flex justify-content-end">
                      <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
                        {{ 'savings-plan.my-savings-plans.rate' | transloco }}
                      </div>
                      <div class="zero-text p-base-reg">
                        {{ savingsPlan.amount | currency }}
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="d-flex justify-content-end">
                      <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
                        {{ 'savings-plan.my-savings-plans.interval' | transloco }}
                      </div>
                      <div class="zero-text p-base-reg">
                        {{ 'onboarding.savings-plan.preview.values.interval' | transloco }}
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="d-flex justify-content-end">
                      <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
                        {{ 'savings-plan.my-savings-plans.next-execution' | transloco }}
                      </div>
                      <div class="zero-text p-base-reg text-right">
                        {{ 'onboarding.savings-plan.preview.values.execution' | transloco }}
                      </div>
                    </div>
                  </td>
                  <td>
                    <web-design-system-icon-button
                      (click)="currentlyDeletingId = savingsPlan.id"
                      icon="trash"
                      size="x-small"
                      type="old-savings-plan"
                    />
                  </td>
                </tr>
                @if (currentlyDeletingId === savingsPlan.id) {
                  <tr>
                    <td colspan="5">
                      <div class="d-flex justify-content-center align-items-center gap">
                        <web-design-system-button
                          [disabled]="facade.deletingOnboardingSavingsPlan$ | async"
                          type="secondary"
                          size="small"
                          (click)="facade.deleteOnboardingSavingsPlan(savingsPlan.id)"
                        >
                          {{ 'savings-plan.my-savings-plans.delete' | transloco }}
                        </web-design-system-button>
                        <a class="link-secondary cursor-pointer" (click)="currentlyDeletingId = null">
                          {{ 'savings-plan.my-savings-plans.abort' | transloco }}
                        </a>
                      </div>
                    </td>
                  </tr>
                }
              }
            </tbody>
          </table>
        } @else {
          <p class="mt-3">{{ 'savings-plan.my-savings-plans.no-plans.hint' | transloco }}</p>
        }
      }
    </div>
  </div>
</div>
